<template>
  <Modal>
    
    <template v-slot:float>
      <img id="cookie-bird-img" src="@/assets/img/cookie_bird.svg" />
    </template>

    <template v-slot:header>
      <h2>Vi bruger cookies</h2>
    </template>

    <p>Vi benytter tredjeparts-cookies <br> på Tripply.dk til: </p>
    <ul>
      <li>Nødvendige funktioner</li>
      <li>Statistik og webanalyse</li>
    </ul>
    <p>Vi bruger <u>ikke</u> cookies til markedsføring.</p>
    <p><a @click="showMore = true" href="#">Læs mere om vores cookies</a></p>

    <template v-slot:footer>
      <AppButton @click="accept()" color="primary">Jeg accepterer</AppButton>
    </template>

    <Modal v-model="showMore" closable wide>
      <template v-slot:header>
        <h2>Cookie- og privatlivspolitik</h2>
      </template>
      <PrivacyPage />
      <template v-slot:footer>
       <AppButton @click="accept()" color="primary">Jeg accepterer</AppButton>
      </template>
    </Modal>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, ref, reactive } from 'vue'
import { store } from '@/store'
import PrivacyPage from '@/views/pages/Privacy.vue'

export default defineComponent({
  props: {
    routeId: String
  },
  components: { PrivacyPage },
  name: 'CookieConsent',
  setup() {

    const showMore = ref(false)

    const consents = reactive({
      cookie: false,
      privacy: false
    })

    function accept() {
      store.global.acceptCookies()
    }
    
    return { accept, consents, showMore }
  }
})
</script>

<style lang="scss" scoped>
#cookie-bird-img {
  position: absolute;
  right: -2.5rem;
  bottom: 4rem;
  width: 14rem;
}
</style>